<template>
	<c-dialog ref="dialog" mode="slide" width="800" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">
		<c-tips v-if="freeEdition">工序最多可创建{{systemConfig.free_process_count}}个</c-tips>
		<c-form ref="form" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="工序编号">
				<c-input name="process_code" placeholder="请输入，忽略将自动生成"></c-input>
			</c-form-item>
			<c-form-item label="工序名称" required>
				<c-input name="process_name"></c-input>
			</c-form-item>
			<c-form-item label="部门报工权限" tip="部门和用户都不选择,则所有员工都可对当前工序进行报工">
				<c-select name="department_ids" async multiple @search="searchDepartment" :value-data="selectedDepartment"></c-select>
			</c-form-item>
			<c-form-item label="员工报工权限" tip="部门和用户都不选择,则所有员工都可对当前工序进行报工">
				<c-select name="user_ids" async multiple @search="searchUser" :value-data="selectedUser"></c-select>
			</c-form-item>
			<c-form-item label="报工数配比" required tip="默认任务计划数 = 工单计划数 * 报工数配比">
				<c-input type="stepper" decimal="6" name="output_ratio" :range="[0.01,99999999]"></c-input>
			</c-form-item>
			<c-form-item label="不良品项列表" required>
				<c-transfer ref="defectsList" name="defects_list" async multiple  @search="searchDefects" :value-data="selectedDefects" :title="['可选不良品项', '已选不良品项']"></c-transfer>
				<!-- <c-select name="defects_list" async multiple  @search="searchDefects" :value-data="selectedDefects"></c-select> -->
				<template #tip>
					<c-link icon @click="globalDialog('defectsEdit', $refs.defectsList.searchHandle);">新增不良品项</c-link>
				</template>
			</c-form-item>
            <!--工序图-->
            <c-form-item label="工序图">
                <c-upload-file name="process_image" type="image" size="5120" button="选择图片" media></c-upload-file>
            </c-form-item>
			<c-form-item label="加工类型">
				<c-radio-group name="process_type" :options="processTypeDic" v-model="process_type" :disabled="freeEdition" @change="processTypeHandle"></c-radio-group>
				<div v-if="freeEdition" style="margin-top:-20px;margin-left:-85px;">
					<c-tooltip tip="此功能为【专业版】功能，请开通专业版后使用" align="end">
						<template><img src="@/assets/image/vip.png" alt="" style="height: 14px;"></template>
					</c-tooltip>
				</div>
			</c-form-item>
			<c-form-item label="检验方式">
				<c-radio-group name="test_mode" :options="testModeDic" v-model="test_mode" :disabled="process_type==2 || freeEdition" @change="testModeHandle"></c-radio-group>
				<div v-if="freeEdition" style="margin-top:-20px;margin-left:-85px;">
					<c-tooltip tip="此功能为【专业版】功能，请开通专业版后使用" align="end">
						<template><img src="@/assets/image/vip.png" alt="" style="height: 14px;"></template>
					</c-tooltip>
				</div>
			</c-form-item>
			<c-form-item label="物料自动出库" :tip="process_type==1?'自制：当前工序报工后,对应工序需要用到的物料会自动出库,无需手动操作领料':'外协：当前工序对应的委外单发货时,对应外协工序需要用到的物料会自动出库,无需手动发料'">
				<c-radio-group name="material_auto_out" :options="openCloseDic"></c-radio-group>
				<!-- <c-switch name="material_auto_out" :state-value="[1, 0]" :state-text="['开启','不启用']" ></c-switch> -->
			</c-form-item>
			<c-form-item label="成品自动入库" tip="当前工序报工后,生产的成品会自动入库,无需手动再操作入库">
				<c-radio-group name="product_auto_in" :options="openCloseDic" :disabled="test_mode!=1"></c-radio-group>
				<!-- <c-switch name="product_auto_in" :state-value="[1, 0]" :state-text="['开启','不启用',]" ></c-switch> -->
			</c-form-item>
			<c-form-item label="报工前打卡" tip="工人开始工作时手动打卡,只有存在开始工作打卡记录才允许报工">
				<c-radio-group name="output_start" :options="openCloseDic" :disabled="process_type==2"></c-radio-group>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="9"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
export default {
	name: 'processEdit',
	
	data() {
		return {
			selectedUser:[],
			selectedDepartment:[],
			selectedDefects:[],
			process_type:1,
			test_mode:1
		}
	},
	
	computed: {
		...mapState(['openCloseDic','processTypeDic','testModeDic','systemConfig']),
		...mapGetters(['freeEdition'])
	},

	methods: {
		/*********打开编辑框，初始化**********/
		async open(data) {
			this._editState = !!data;
			if (!this._editState && !(await this.checkDataCount('PROCESS')).data) return;
			this.selectedUser = [];
			this.selectedDepartment = [];
			this.selectedDefects =[];
			
			this.$refs.form.clear();
			this.$refs.customForm.init();
			if (data) {
				this.$refs.form.set(data);
				
				//查询工序详情
				this.request({
					url:'/dic/process/detail',
					data: {
						id:data.id
					},
					success:data => {
						this.$refs.form.set(data.detailInfo);
						this.process_type = data.detailInfo.process_type;
						
						//已选中的[用户]
						if (data.authUserList){
							this.selectedUser = data.authUserList.map(item => {
								return {
									name:item.user_realname,
									value:item.id
								}
							});
						}
						//已选中的[部门]
						if (data.authDepartmentList){
							this.selectedDepartment = data.authDepartmentList.map(item => {
								return {
									name:item.department_name,
									value:item.id
								}
							});
						}
						//已选中的[不良品项]
						this.selectedDefects = data.defectsList.map(item => {
							return {
								name: item.defects_code +" | "+item.defects_name,
								value:item.id
							}
						});
					}
				})
			}else{
				this.$refs.form.set({
					output_ratio:1,
					process_type:1,
					test_mode:1,
					output_start:0,
					material_auto_out:0,
					product_auto_in:0
				});
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑工序' : '创建工序'
			});
		},
		
		/**加工类型变更事件*/
		processTypeHandle(data){
			if(data == 2){
				this.$refs.form.set({
					test_mode:1,
					output_start: 0,
					material_auto_out:0
				});
			}
		},
		
		/**检验方式变更事件*/
		testModeHandle(data){
			if(data != 1){
				this.$refs.form.set({
					product_auto_in:0
				});
			}
		},

		/*******搜索用户*****************/
		searchUser(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SYSUSER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索部门*****************/
		searchDepartment(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DEPARTMENT',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索不良品项********/
		searchDefects(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DICDEFECTS',
					max_count: 500,
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/dic/process/edit':'/dic/process/add',
				rule: {
					process_name: '请输工序名称',
					output_ratio:'请输入报工数配比',
					defects_list:'请选择不良品项',
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					//保存自定义字段值对象副本，供 resolve 回传（提交体需字符串化）
					this._customFieldsValue = data.custom_fields_value_json || {};
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容、
						type: 'success'
					});
					//回传自定义字段值对象，供调用方（如工艺路线工序行）回写
					this.$emit('resolve', Object.assign({}, res, {custom_fields_value_json: this._customFieldsValue}));
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>